import { RichTextV2ControlType } from "./rich-text-v2";
import { v4 as uuid } from "uuid";
import { BlockType } from "../../slate/types";
function richTextV2DataToDescendents(data) {
  return data.descendants.length === 0 ? [{ type: BlockType.Default, children: [{ text: "" }] }] : data.descendants;
}
function richTextV2DescendentsToData(descendants, key) {
  return {
    type: RichTextV2ControlType,
    version: 2,
    descendants,
    key: key ?? uuid()
  };
}
export {
  richTextV2DataToDescendents,
  richTextV2DescendentsToData
};
//# sourceMappingURL=dto.js.map